<template>
    <section>
        <b-modal :active.sync="isActive" has-modal-card @close="close">
            <div class="modal-card" style="">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{role.name}}</p>
                </header>
                <section class="modal-card-body">
                    <b-tabs v-model="selectedTabIndex">
                        <b-tab-item label="Details">
                            <div v-if="role.user">
                                <router-link :to="'/user/' + role.user.username">
                                    <article class="media">
                                      <figure class="media-left">
                                        <p class="image is-32x32">
                                          <img class='is-rounded' :src="role.user.image[0].sizes.circularList" />
                                        </p>
                                      </figure>
                                      <div class="media-content">
                                          <span>{{role.user.firstName}} {{role.user.lastName}}</span>
                                      </div>
                                    </article><br/>
                                </router-link>
                            </div>

                            <div v-if="!isOwnProject" class="content" v-html="role.body"></div>

                            <div v-if="isOwnProject">
                                <b-field label="Name">
                                    <b-input v-model="role.name"></b-input>
                                </b-field>

                                <b-field>
                                    <vue-editor id="editor-sm" v-model="role.body" :editorToolbar="customToolbar"></vue-editor>
                                </b-field>

                                <button class="button is-success" @click="saveRole">Save</button>
                            </div>
                        </b-tab-item>
                        <b-tab-item label="Applications" v-if="!role.user && !isNewRole && this.$root.isLoggedIn && isOwnProject">
                            <!-- role.applications.length -->
                            <div class="well" v-if="role.applications && role.applications.length === 0">
                                <h3 class='title is-4'>There are no applications!</h3>
                                <h4 class='subtitle is-6'>No students have applied to this position yet</h4>
                                <p>Applications of students wishing to fill this position will appear here. We recommend you continue to expand your project page to pique interest,
                                    and network on your campus and on social media to spread the word!</p>
                            </div>
                            <b-collapse v-for="application in role.applications" :key="application.id" class="card">
                                <div
                                    slot="trigger"
                                    slot-scope="props"
                                    class="card-header"
                                    role="button"
                                    aria-controls="contentIdForA11y3">
                                    <div class="card-header-title">
                                        <figure class="image is-32x32">
                                            <img class='is-rounded' :src="application.user.image" />
                                        </figure>&nbsp;
                                        <span>{{application.user.firstName}} {{application.user.lastName}}</span>
                                    </div>
                                    <a class="card-header-icon">
                                        <b-icon :icon="props.open ? 'menu-down' : 'menu-up'"></b-icon>
                                    </a>
                                </div>
                                <div class="card-content">
                                    <div class="content">
                                        <p>{{application.message}}</p>
                                        <div class='is-pulled-left'>
                                            <router-link class="button is-text" :to="'/user/' + application.user.username">
                                                <b-icon icon="account" />
                                                <span>Profile</span>
                                            </router-link>
                                            <a class='button is-text' :href="'mailto:' + application.user.email">
                                                <b-icon icon="email-outline" />
                                                <span>Email</span>
                                            </a>
                                        </div>
                                        <div class='is-pulled-right'>
                                            <b-tooltip label="Add this applicant to the team (removes all other applications)"
                                                type="is-dark"
                                                position="is-left">
                                                <a @click="approveApplication(application)" class='button is-success is-outlined'>Approve</a>
                                            </b-tooltip>
                                            <b-tooltip label="Remove this application from consideration"
                                                type="is-dark"
                                                position="is-left">
                                                <a @click="ignoreApplication(application)" class='button is-text'>Ignore</a>
                                            </b-tooltip>
                                        </div>
                                        <span class='is-clearfix'></span>
                                    </div>
                                </div>
                            </b-collapse>
                        </b-tab-item>
                        <b-tab-item label="Manage" v-if="isOwnProject && !isNewRole">
                            <div class='manage-box danger'>
                                <nav class="level" v-if="role.user">
                                  <div class="level-left">
                                      <p><strong>Remove user</strong></p>
                                      <p>Removes {{role.user.firstName}} from this position</p>
                                  </div>

                                  <div class="level-right">
                                    <button v-if="isOwnProject && role.user" class="button is-danger is-outlined" @click="removeUser">Remove</button>
                                  </div>
                                </nav>

                                <hr v-if="role.user"/>

                                <nav class="level">
                                  <div class="level-left">
                                      <p><strong>Delete position</strong></p>
                                      <p>Permanently deletes this position</p>
                                  </div>

                                  <div class="level-right">
                                    <button v-if="isOwnProject" class="button is-danger is-outlined" @click="deleteRole">Delete</button>
                                  </div>
                                </nav>
                            </div>
                        </b-tab-item>
                        <b-tab-item label="Apply" v-if="$root.isLoggedIn && $root.user.accountType == 'student' && !isNewRole && !role.user && !$root.applications.find((app) => { return app.role === this.role.id})">
                            <b-field label="Message">
                                <b-input type="textarea" v-model="applyMessage" maxlength="300"></b-input>
                            </b-field>
                            <button class='button is-success' @click="applyToRole">Send application</button>
                            <button class='button' @click="clearInProgressApplication">Cancel</button>
                        </b-tab-item>
                    </b-tabs>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" type="button" @click="close">Close</button>
                </footer>
            </div>
        </b-modal>
    </section>
</template>

<style scoped>
.manage-box {
  border: 1px SOLID #ddd;
  border-radius: 2px;
  padding: 20px;
}
.level-left {
  display: block;
}
</style>

<script>
    export default {
        name: 'RoleModal',
        data() {
            return {
                customToolbar: [
                    [{ 'header': [1, 2, 3, false] }],

                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote'],

                    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
                    // [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent

                    // [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    // [{ 'font': [] }],
                    // [{ 'align': [] }],

                    ['clean']                                         // remove formatting button
                ],
                applyMessage: ''
            }
        },
        props: ['role', 'isActive', 'isOwnProject', 'projectId', 'selectedTabIndex'],
        computed: {
            isNewRole: function() {
                return !this.role.id;
            }
        },
        methods: {
            close: function() {
                this.$emit('close');
            },
            clearInProgressApplication: function() {
                // User wants to cancel their application that they were filling out
                this.applyMessage = '';
                this.selectedTabIndex = 0;
            },
            removeUser: function() {
                this.$http.post(this.$hostname + '/role/' + this.role.id + '/removeUser').then(function(response) {
                    this.$toast.open({
                      message: 'User removed from position ' + this.role.name,
                      type: 'is-success',
                      queue: false
                    })
                    this.$emit('teammateRemoved', this.role);
                    this.close();
                }, function(error) {
                    this.$toast.open({
                      message: 'Could not remove user from position! ' + error.body.message,
                      type: 'is-danger',
                      queue: false
                    })
                });
            },
            applyToRole: function() {
                this.$http.put(this.$hostname + '/role/' + this.role.id + '/apply', { message: this.applyMessage }).then(function(response) {
                    this.$toast.open({
                      message: 'You have submitted your application for ' + this.role.name,
                      type: 'is-success',
                      queue: false
                    })

                    this.selectedTabIndex = 0;
                    this.$root.applications.push(response.body); // the body contains the application that was created
                    this.applyMessage = '';
                    this.close();
                    this.$emit('userApplied', { role: this.role, application: response.body });
                }, function(error) {
                    this.$toast.open({
                      message: 'Could not apply! ' + error.body.message,
                      type: 'is-danger',
                      queue: false
                    })
                });
            },
            ignoreApplication: function(application) {
                this.$http.delete(this.$hostname + '/application/' + application.id + '?projectId=' + this.projectId).then(function(response) {
                    this.$emit('roleApplicationDeleted', application);
                }, function(error) {
                    this.$toast.open({
                      message: 'Could not delete this application! Please try again',
                      type: 'is-danger',
                      queue: false
                    })
                });
            },
            approveApplication: function(application) {
                this.$http.post(this.$hostname + '/application/' + application.id + '/approve', { projectId: this.projectId }).then(function(response) {
                    this.$toast.open({
                      message: 'Application approved! ' + application.user.firstName + ' is now on your team',
                      type: 'is-success',
                      queue: false
                    })

                    this.$emit('teammateAdded', { user: response.body, roleId: application.role });
                    this.close();
                }, function(error) {
                    this.$toast.open({
                      message: 'Could not approve this application! Please try again',
                      type: 'is-danger',
                      queue: false
                    })
                });
            },
            saveRole: function() {
                var isNewRole = !this.role.id;
                var method = isNewRole ? 'put' : 'post';
                var path = this.$hostname + '/role'; // id is not required for updating; it is sent in the body
                var reqBody = this.role;

                reqBody.projectId = this.projectId; // send project ID so it knows which project it belongs to; plus always needed for `isProjectOwner` policy
                this.$http[method](path, reqBody).then(function(response) { // create
                    this.$toast.open({
                      message: isNewRole ? 'Created a new position!' : 'Updated the position ' + this.role.name,
                      type: 'is-success',
                      queue: false
                    })

                    if(!response.body.applications) response.body.applications = []; // may not contain applications array, so add it
                    this.$emit(isNewRole ? 'roleCreated' : 'roleUpdated', response.body); // response contains updated Role record
                    this.close();
                }, function(error) {
                    this.$toast.open({
                      message: 'Could not save role! Please try again',
                      type: 'is-danger',
                      queue: false
                    })
                });
            },
            deleteRole: function() {
                this.$http.delete(this.$hostname + '/role/' + this.role.id + '?projectId=' + this.projectId).then(function(response) {
                    this.$toast.open({
                      message: 'Position was deleted',
                      type: 'is-success',
                      queue: false
                    })

                    this.$emit('roleDeleted', response.body); // response contains updated Role record
                    this.close();
                }, function(error) {
                    this.$toast.open({
                      message: 'Position could not be deleted. Please try again',
                      type: 'is-danger',
                      queue: false
                    })
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/RoleModal.vue